import React from 'react'
import { AuthProvider } from 'react-oidc-context'
import { OidcConfig } from './HomeScreen'

export const AuthWrapper = ({ children }) => <AuthProvider {...OidcConfig}>{children}</AuthProvider>
